<template>
  <div v-if="result.length > 0" class="home">
    <div v-if="isMaxScreen" class="main-content">
      <div class="check-condition">
        <!-- 云检信息 -->
        <h4>
          <!-- Predict the machine condition -->
          {{ $t('component.tradeInProcess.checkTitle') }}
        </h4>
        <!-- 最终价格 -->
        <!--
          "2", descs:"待检测"
          "3", descs:"待解锁"
          "4", descs:"待议价"
          "7", descs:"已成交"
          "15", descs:"带锁已成交"
          "17", descs:"已售出"
          "18", descs:"已退单"
        -->
        <final-price
          v-if="[3, 4, 7, 15, 17, 18].includes(Number(orderInfo?.goodsStatus))"
          :orderInfo="orderInfo"
          @finalPriceClick="finalPriceClick"
        ></final-price>
        <div :class="['basic-info', { 'basic-info-wrap': result && result.length > 4 }]">
          <div v-for="(item, index) in result" :key="index" class="basic-info-item">
            <div class="basic-info-content">
              <div class="basic-info-content-title">
                <img
                  :src="require(`../../../assets/image/order/${index + 7}.png`)"
                  alt=""
                  class="basic-info-icon"
                />
                <span>{{ item.attributeName }}</span>
              </div>
              <div class="basic-info-content-text-box">
                <span class="basic-info-content-text"
                  >{{ $t('component.tradeInProcess.656g0lj3pda2') }}：
                  {{ item.attributeValue1 }}
                </span>
                <span class="basic-info-content-text"
                  >{{ $t('component.tradeInProcess.656g0lj3ed3d') }}：
                  {{ item.attributeValue2 }}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div>
          <h5 class="title">{{ $t('component.tradeInProcess.detectionResult') }}</h5>
          <div class="qcPictures">
            <el-image
              v-for="(url, index) in orderInfo.qcPictures"
              :key="index"
              :src="url"
              alt=""
              class="qcPictures-img"
              :preview-src-list="orderInfo.qcPictures"
            >
            </el-image>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="main-content">
      <div class="check-condition">
        <!-- 云检信息 -->
        <h4>{{ $t('component.tradeInProcess.checkTitle') }}</h4>
        <!-- 最终价格 -->
        <!--
          "2", descs:"待检测"
          "3", descs:"待解锁"
          "4", descs:"待议价"
          "7", descs:"已成交"
          "15", descs:"带锁已成交"
          "17", descs:"已售出"
          "18", descs:"已退单"
        -->
        <final-price
          v-if="[3, 4, 7, 15, 17, 18].includes(Number(orderInfo?.goodsStatus))"
          :orderInfo="orderInfo"
          @finalPriceClick="finalPriceClick"
        ></final-price>
        <h5 class="title">{{ $t('component.tradeInProcess.basicInformation') }}</h5>
        <div class="basic-info">
          <div v-for="(item, index) in result" :key="index" class="basic-info-item">
            <img
              :src="require(`../../../assets/image/order/${index + 7}.png`)"
              alt=""
              class="basic-info-icon"
            />
            <div class="basic-info-content">
              <div class="basic-info-content-title">{{ item.attributeName }}</div>
              <span class="basic-info-content-text"
                >{{ $t('component.tradeInProcess.656g0lj3pda2') }}： <br />

                {{ item.attributeValue1 }}
              </span>
              <span class="basic-info-content-text"
                >{{ $t('component.tradeInProcess.656g0lj3ed3d') }}： <br />
                <!-- <img
                  :src="
                    item.attributeValue2 == 'Yes'
                      ? require('../../../assets/image/order/11.png')
                      : require('../../../assets/image/order/13.png')
                  "
                  alt=""
                  class="icon-status"
                /> -->
                {{ item.attributeValue2 }}
              </span>
            </div>
          </div>
        </div>
        <!--  -->
        <template v-if="orderInfo.qcPictures.length > 0">
          <h5 class="title">{{ $t('component.tradeInProcess.detectionResult') }}</h5>
          <div class="qcPictures">
            <!-- <img src="" alt="">  qcPictures-->
            <img
              v-for="(url, index) in orderInfo.qcPictures"
              :key="index"
              :src="url"
              alt=""
              class="qcPictures-img"
              @click="showImage(index)"
            />
            <van-image-preview
              v-model="show"
              :images="orderInfo.qcPictures"
              :startPosition="startPosition"
            >
            </van-image-preview>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import finalPrice from './finalPrice.vue';
export default {
  name: 'OrderCheck',
  components: {
    finalPrice
  },
  props: {
    orderInfo: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      result: [],
      show: false,
      startPosition: 0
    };
  },
  computed: {
    ...mapState({
      isMaxScreen: state => state.isMaxScreen
    })
  },
  watch: {
    orderInfo(val) {
      // if (!val.qcConditions) return;
      // const estimatedConditions = val.estimatedConditions;
      // const qcConditions = val.qcConditions;

      // // 创建一个对象用于存储统计结果
      // const result = {};
      // // 遍历estimatedConditions数组
      // estimatedConditions.forEach(item => {
      //   const attributeId = item.attributeName.split('|')[0];
      //   const attributeName = item.attributeName.split('|')[1];
      //   const attributeValue = item.attributeValue.split('|')[1];
      //   result[attributeId] = {
      //     attributeId: attributeId,
      //     attributeName: attributeName,
      //     attributeValue1: attributeValue,
      //     attributeValue2: null
      //   };
      // });

      // // 遍历qcConditions数组
      // qcConditions.forEach(item => {
      //   const attributeId = item.attributeName.split('|')[0];
      //   // const attributeName = item.attributeName.split('|')[1];
      //   const attributeValue = item.attributeValue.split('|')[1];
      //   // 如果result中已存在相同name的项，则更新Value2
      //   if (result[attributeId]) {
      //     result[attributeId].attributeValue2 = attributeValue;
      //   }
      // });

      // // 将result对象转换为数组形式
      // const Arr = Object.values(result);
      // console.log(Arr);
      // this.result = Arr;
      if (!val.qcConditions) {
        return;
      }

      const { estimatedConditions, qcConditions } = val;
      const nationCode = this.$route.query.nationCode || 'GB'; // Default to GB

      // Configuration for different nation codes
      const nationConfigs = {
        ES: {
          attributeNames: {
            3: '¿Está desbloqueado y funciona correctamente?',
            4: '¿El cuerpo del teléfono está en buen estado?',
            5: '¿La pantalla está en buen estado?',
            6: '¿Todas las funciones funcionan correctamente?',
            7: '¿El dispositivo está gravemente dañado o no puede encenderse?'
          },
          valueTranslations: {
            15: 'No apto para reciclaje',
            16: 'En excelente estado',
            17: 'Ligeras señales de uso',
            18: 'Signos visibles de uso',
            7: 'YES',
            8: 'NO',
            9: 'YES',
            10: 'NO',
            11: 'YES',
            12: 'NO',
            13: 'YES',
            14: 'NO'
          }
        },

        IT: {
          attributeNames: {
            7: 'Il dispositivo è gravemente danneggiato o non si accende?'
          },
          valueTranslations: {
            15: 'Non idoneo al riciclo',
            16: 'In condizioni eccellenti',
            17: 'Leggeri segni di utilizzo',
            18: 'Segni visibili di utilizzo'
          }
        },

        FR: {
          attributeNames: {
            7: 'L\'appareil est-il gravement endommagé ou impossible à allumer',
            3: 'Sbloccato e acceso?',
            4: 'Scocca del in buone condizioni?',
            5: 'Schermo in buone condizioni?',
            6: 'Il telefono funziona correttamente?'
          },
          valueTranslations: {
            15: 'Non éligible au recyclage',
            16: 'En excellent état',
            17: 'Légères traces d’utilisation',
            18: 'Traces d’utilisation visibles',
            7: 'YES',
            8: 'NO',
            9: 'YES',
            10: 'NO',
            11: 'YES',
            12: 'NO',
            13: 'YES',
            14: 'NO'
          }
        },

        GB: {
          attributeNames: {
            7: 'Is the device severely damaged or unable to power on?',
            3: 'Can it be unlocked and powered on?',
            4: 'Is the screen in good condition?',
            5: 'Is the phone body in good condition?',
            6: 'Does the device function normally?'

          },
          valueTranslations: {
            15: 'Not eligible for recycling',
            16: 'Excellent Condition',
            17: 'Light Signs of Use',
            18: 'Visible Signs of Use',
            7: 'YES',
            8: 'NO',
            9: 'YES',
            10: 'NO',
            11: 'YES',
            12: 'NO',
            13: 'YES',
            14: 'NO'
          }
        },

        PT: {
          attributeNames: {
            3: 'Pode ser desbloqueado e ligado?',
            4: 'O ecrã está em boas condições?',
            5: 'O corpo do telemóvel está em boas condições?',
            6: 'O dispositivo funciona normalmente?',
            7: 'O dispositivo está gravemente danificado ou não liga?'
          },
          valueTranslations: {
            15: 'Não elegível para reciclagem',
            16: 'Excelente estado',
            17: 'Ligeiros sinais de uso',
            18: 'Sinais visíveis de uso',
            7: 'SIM',
            8: 'NÃO',
            9: 'SIM',
            10: 'NÃO',
            11: 'SIM',
            12: 'NÃO',
            13: 'SIM',
            14: 'NÃO'
          }
        },

        PL: {
          attributeNames: {
            3: 'Czy urządzenie można odblokować i włączyć?',
            4: 'Czy ekran jest w dobrym stanie?',
            5: 'Czy obudowa telefonu jest w dobrym stanie?',
            6: 'Czy urządzenie działa prawidłowo?',
            7: 'Czy urządzenie jest poważnie uszkodzone lub nie można go włączyć?'
          },
          valueTranslations: {
            15: 'Nie kwalifikuje się do recyklingu',
            16: 'Stan doskonały',
            17: 'Niewielkie ślady użytkowania',
            18: 'Widoczne ślady użytkowania',
            7: 'TAK',
            8: 'NIE',
            9: 'TAK',
            10: 'NIE',
            11: 'TAK',
            12: 'NIE',
            13: 'TAK',
            14: 'NIE'
          }
        }
      };

      // Process the data
      const result = {};

      // Helper function to process attribute values
      const processValue = (value, config) => {
        console.log(value, config);
        if (!value || !config) {
          return value;
        }
        return config.valueTranslations?.[value] || value;
      };

      // Process estimated conditions
      estimatedConditions.forEach(item => {
        const [attributeId, attributeName] = item.attributeName.split('|');
        const attributeValue = item.attributeValue.split('|')[0];

        result[attributeId] = {
          attributeId,
          attributeName,
          attributeValue1: attributeValue,
          attributeValue2: null
        };
      });

      // Process QC conditions
      qcConditions.forEach(item => {
        const [attributeId] = item.attributeName.split('|');
        const attributeValue = item.attributeValue.split('|')[0];
        if (result[attributeId]) {
          result[attributeId].attributeValue2 = attributeValue;
        }
      });

      // Apply nation-specific transformations if config exists
      const config = nationConfigs[nationCode];
      let Arr = Object.values(result);

      if (config) {
        Arr = Arr.map(item => ({
          ...item,
          attributeName: config.attributeNames?.[item.attributeId] || item.attributeName,
          attributeValue1: processValue(item.attributeValue1, config),
          attributeValue2: processValue(item.attributeValue2, config)
        }));
      }

      console.log(Arr);
      this.result = Arr;
    }
  },
  created() {},
  methods: {
    showImage(index) {
      this.show = true;
      this.startPosition = index;
    },
    finalPriceClick(type) {
      this.$emit('finalPriceClick', type);
    }
  }
};
</script>
<style scoped lang="less">
@media (max-width: 980px) {
  h4 {
    color: var(---Text-1, #252629);
    font-family: 'PingFang SC';
    font-size: 30px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    margin: 32px;
    text-align: left;
  }

  .title {
    font-size: 28px;
    margin: 32px;
  }

  .qcPictures {
    display: flex;
    justify-content: space-between;
    margin: 32px;
    .qcPictures-img {
      width: 148px;
      height: 148px;
      border-radius: 8px;
      flex-shrink: 0;
      margin-right: 10px;
      &:last-child {
        margin-right: 0;
      }
    }
  }

  .check-condition {
    width: 686px;
    flex-shrink: 0;
    border-radius: 24px;
    background: #fff;
    margin: 24px auto;
    padding-bottom: 12px;
    overflow: hidden;

    .basic-info {
      display: flex;
      flex-direction: column;

      // height: 172px;
      flex-shrink: 0;
      margin: 0px 32px;

      .basic-info-item {
        display: flex;
        padding: 24px 32px;
        border-radius: 12px;
        background: #f7f7f7;
        // width: 622px;
        margin-bottom: 20px;

        .basic-info-icon {
          width: 48px;
          height: 48px;
        }

        .basic-info-content {
          display: flex;
          flex-direction: column;
          margin-left: 32px;

          .basic-info-content-title {
            color: #333;
            font-family: 'PingFang SC';
            font-size: 28px;
            font-style: normal;
            font-weight: 600;
            line-height: normal;

          }

          .basic-info-content-text {
            display: flex;
            align-items: center;
            margin-top: 15px;
            line-height: 40px;
            // margin-bottom: 10px;
            color: #666;

            .icon-status {
              width: 24px;
              height: 24px;
              margin: 0 4px;
            }
          }
        }
      }
    }

    .tip1 {
      color: #ff9602;
      font-family: 'PingFang SC';
      font-size: 18px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    }
    .tip2 {
      color: rgba(102, 102, 102, 0.8);
      font-family: 'PingFang SC';
      font-size: 18px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    }
  }

  .tip {
    margin: 0 32px;
    display: inline-block;
  }
}

@media (min-width: 981px) {
  .main-content {
    background: #fff;
  }

  h4 {
    color: var(---Text-1, #252629);
    font-family: 'PingFang SC';
    font-size: 45px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    margin: 50px 0 30px;
    text-align: center;
    // margin-bottom: 120px;
  }

  .title {
    font-size: 24px;
    margin: 32px 0;
    text-align: center;
  }

  .qcPictures {
    display: flex;
    justify-content: center;
  }

  .qcPictures-img {
    border-radius: 18px;
    box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.06);
    width: 400px;
    height: 400px;
    margin: 0 21px;
  }

  .check-condition {
    // width: 686px;
    flex-shrink: 0;
    background: #fff;
    margin: 0 auto 50px;
    padding-bottom: 20px;
    overflow: hidden;
    width: 1920px;
    .basic-info {
      display: flex;

      // height: 172px;
      flex-shrink: 0;
      justify-content: center;
      // margin: 20px 32px;

      .basic-info-item {
        display: flex;
        padding: 24px 0 24px 24px;
        border-radius: 12px;
        background: #f7f7f7;
        width: 976px;
        margin-bottom: 20px;
        // margin-right: 30px;
        align-items: center;
        justify-content: center;
        // flex: 1;

        .basic-info-icon {
          width: 24px;
          height: 24px;
        }

        .basic-info-content {
          display: flex;
          flex-direction: column;
          margin-left: 24px;

          .basic-info-content-title {
            color: #333;
            font-family: 'PingFang SC';
            font-size: 21px;
            font-style: normal;
            font-weight: 600;
            line-height: normal;
            display: flex;
            gap:  10px; /* 行间距 列间距 */
            align-items: center;
            justify-content: center;
            margin-bottom: 8px;
          }

          .basic-info-content-text-box {
            display: flex;
            flex-direction: column;
            align-items: center;
          }

          .basic-info-content-text {
            display: flex;
            align-items: center;
            // margin-top: 8px;
            font-size: 18px;
            margin: 8px;
            color: #666;
            display: block;

            .icon-status {
              width: 24px;
              height: 24px;
              margin: 0 4px;
            }
          }
        }
      }
      &.basic-info-wrap {
        flex-wrap: wrap;
        justify-content: center;
        .basic-info-item {
          flex: none;
          width: 25%;
        }
      }
    }
  }

  .tip {
    margin: 0 32px;
    display: inline-block;
    width: 1180px;
    height: 150px;
    margin: 0 auto;
    border-radius: 21px;
    border: 2px solid #efefef;
    display: flex;
    justify-content: center;
    padding: 33px;
    align-items: center;
    .tip-left {
      color: #ff9602;
      font-family: 'PingFang SC';
      font-size: 45px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
      margin-right: 30px;
    }
    .tip-right {
      width: 340px;
      height: 100%;
      border-radius: 31px;
      background: #f7f7f7;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .total-price {
        color: #666;
        font-family: 'PingFang SC';
        font-size: 21px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
      }

      .coin-price {
        display: flex;
        align-items: flex-end;
        margin-top: 10px;
      }
      .price {
        flex: 1;
        font-size: 50px;
        line-height: 1;
        color: #ff9602;
      }
      .coin {
        flex: 1;
        font-size: 25px;
        line-height: 1;
        color: #ff9602;
        margin-bottom: 5px;
      }
    }
  }
}
</style>
